module.exports = __webpack_public_path__ + "fr.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/fr.png
// module id = 1064
// module chunks = 0